class CustomShop {
  constructor(container) {
    this.container = container;
    this.sliderEl = this.container.querySelector('.cstm-collection-tabs-slider');
    this.productGridEl = this.container.querySelector('#cstm-product-grid-container');
    this.loaderEl = this.container.querySelector('#cstm-infinite-scroll-loader');
    this.gridOverlayEl = this.container.querySelector('#cstm-product-grid-overlay');
    this.headerEl = this.container.querySelector('.cstm-product-table-header');
    this.toolbarEl = this.container.querySelector('#cstm-product-toolbar');
    this.productCountEl = this.container.querySelector('#cstm-product-count');
    this.searchInputEl = this.container.querySelector('#cstm-product-search-input');
    this.filterDrawerContainer = this.container.querySelector('#cstm-filter-drawer-container');
    this.filterButton = this.container.querySelector('#cstm-product-filter-button');

    this.currentCollection = null;
    this.currentFilters = '';
    this.sortOrder = this.container.dataset.sortOrder || 'default';
    this.collectionCache = {};
    this.cachePromises = {};
    this.currentLoadId = null;

    this._initSlider();
    this._initTabEvents();
    this._initToolbar();
    this._initFilterDrawer();
    // Inisialisasi fungsi-fungsi helper Anda
    this._initAddToCart();
    this._initQuantityValidation();
    this._initTagToggle();
    this._initSpecDrawer();
    this._initViewMore();
    this._initModelFilterExtras();

    if (this.toolbarEl) this.toolbarEl.style.display = 'flex';

    const firstTab = this.container.querySelector('.cstm-collection-tab');
    if (firstTab) {
      firstTab.click();
    }
  }

  _initSlider() {
    if (this.sliderEl.swiper) this.sliderEl.swiper.destroy(true, true);
    const mobileSlides = parseFloat(this.sliderEl.dataset.mobileSlides) || 3;
    const desktopSlides = parseFloat(this.sliderEl.dataset.desktopSlides) || 5;
    new Swiper(this.sliderEl, {
      slidesPerView: mobileSlides, spaceBetween: 12, grabCursor: true,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: { 1024: { slidesPerView: desktopSlides, spaceBetween: 14 } },
    });
  }

  _initTabEvents() {
    const tabs = this.container.querySelectorAll('.cstm-collection-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', (event) => this._handleTabClick(event));
    });
  }

  _initAddToCart() {
    this.productGridEl.addEventListener('click', (event) => this._handleAddToCartClick(event));
  }

  async _handleAddToCartClick(event) {
    const button = event.target.closest('.cstm-add-to-cart-button');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const productRow = button.closest('.cstm-product-row');
    const qtyInput = productRow.querySelector('.cstm-product-row__qty-input');
    const quantity = parseInt(qtyInput.value, 10);

    if (quantity <= 0) {
      alert('Please enter a quantity greater than 0.');
      return;
    }

    const loader = button.querySelector('.cstm-add-to-cart-button__loader');
    const icon = button.querySelector('.cstm-add-to-cart-button__icon');
    
    button.disabled = true;
    if (loader) loader.style.display = 'flex';
    if (icon) icon.style.display = 'none';

    try {
      const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
      const body = JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: sectionsToRender.join(','),
        sections_url: window.location.pathname
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      
      const parsedState = await response.json();

      if (response.status !== 200) {
        let errorMessage = parsedState.description || parsedState.message || 'Could not add item to cart.';
        alert(errorMessage);
        location.reload();
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
         cartIconBubble.innerHTML = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
      }
      
      if (cartDrawer && parsedState.sections['cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = parsedState.sections['cart-drawer'];
        
        const newDrawerContent = tempDiv.querySelector('cart-drawer');
        if (newDrawerContent) {
          cartDrawer.innerHTML = newDrawerContent.innerHTML;
          
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
        }
        
        cartDrawer.open();
      }
      
      qtyInput.value = '0';

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('An error occurred. Please try again.');
    } finally {
      button.disabled = false;
      if (loader) loader.style.display = 'none';
      if (icon) icon.style.display = 'block';
    }
  }

  async _loadCollection(handle) {
    const loadId = Date.now();
    this.currentLoadId = loadId;
    this.currentCollection = handle;

    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (this.gridOverlayEl) this.gridOverlayEl.style.display = 'block';
    if (this.loaderEl) this.loaderEl.style.display = 'none';

    const activeTab = this.container.querySelector(`.cstm-collection-tab[data-collection-handle="${handle}"]`);
    if (activeTab && this.productCountEl) {
      this.productCountEl.textContent = this.currentFilters ? '' : activeTab.dataset.productCount || 0;
    }
    
    let cacheResolver;
    this.cachePromises[handle] = new Promise(resolve => { cacheResolver = resolve; });
    this.collectionCache[handle] = [];

    let page = 1;
    let keepFetching = true;
    let totalProductsFetched = 0;
    const productsPerPage = 20;

    while (keepFetching) {
      if (this.currentLoadId !== loadId) return;

      try {
        const params = new URLSearchParams({ section_id: 'custom-product-grid', page: page });
        const filterParams = new URLSearchParams(this.currentFilters);
        filterParams.forEach((value, key) => params.append(key, value));
        if (this.sortOrder === 'best-selling') params.append('sort_by', 'best-selling');

        const url = `/collections/${handle}?${params.toString()}`;
        const response = await fetch(url);
        const htmlText = await response.text();
        
        if (this.currentLoadId !== loadId) return;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlText;

        const newRows = tempDiv.querySelectorAll('.cstm-product-row');
        if (newRows.length > 0) {
          
          if (page === 1) {
            this.productGridEl.innerHTML = '';
            this.productGridEl.insertAdjacentHTML('beforeend', tempDiv.innerHTML);
            
            if (this.gridOverlayEl) this.gridOverlayEl.style.display = 'none';

            if (newRows.length === productsPerPage && this.loaderEl) {
              this.loaderEl.style.display = 'block';
            }
          } else {
            this.productGridEl.insertAdjacentHTML('beforeend', tempDiv.innerHTML);
          }

          totalProductsFetched += newRows.length;
          newRows.forEach(row => {
            this.collectionCache[handle].push(this._parseProductRow(row));
          });
          page++;
        } else {
          keepFetching = false;
        }
      } catch (error) {
        console.error("Error fetching collection:", error);
        keepFetching = false;
      }
    }
    
    if (this.currentFilters) {
        this.productCountEl.textContent = totalProductsFetched;
    }
    if (this.loaderEl) this.loaderEl.style.display = 'none';
    if (cacheResolver) cacheResolver();
    delete this.cachePromises[handle];
  }

  async _handleTabClick(event) {
    const tab = event.currentTarget;
    const handle = tab.dataset.collectionHandle;
    if (handle === this.currentCollection && !this.currentFilters && this.searchInputEl.value === '') return;

    this.container.querySelectorAll('.cstm-collection-tab').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    this.currentFilters = '';
    if (this.searchInputEl) this.searchInputEl.value = '';
    await this._loadFiltersForCollection(handle);
    this._loadCollection(handle);
  }

  _renderProducts(isReset = false) {
    if (isReset) {
      this.productGridEl.innerHTML = '';
      this.renderedProductCount = 0;
    }

    if (this.activeProductList.length > 0) {
       if(this.headerEl) this.headerEl.style.display = 'grid';
       if(this.toolbarEl) this.toolbarEl.style.display = 'flex';
       if(this.productCountEl) this.productCountEl.textContent = this.activeProductList.length;
    } else {
       if(this.headerEl) this.headerEl.style.display = 'none';
       if(this.toolbarEl) this.toolbarEl.style.display = 'flex';
       this.productGridEl.innerHTML = '<p class="tw-text-center" style="padding-block: 3rem;">No products found.</p>';
    }

    const productsToRender = this.activeProductList.slice(
      this.renderedProductCount,
      this.renderedProductCount + this.productsPerPage
    );

    let newHtml = '';
    productsToRender.forEach(product => { newHtml += product.outerHTML; });
    
    this.productGridEl.insertAdjacentHTML('beforeend', newHtml);
    this.renderedProductCount += productsToRender.length;
  }

  _parseProductRow(rowElement) {
    const product = {
        title: rowElement.querySelector('h2')?.textContent.trim().toLowerCase() || '',
        sku: rowElement.querySelector('[data-product-sku]')?.textContent.trim().toLowerCase() || '',
        outerHTML: rowElement.outerHTML,
    };
    return product;
  }

  _initToolbar() {
    if (!this.searchInputEl) return;
    this.searchInputEl.addEventListener('input', async (event) => {
      if (this.cachePromises[this.currentCollection]) {
        if (this.gridOverlayEl) this.gridOverlayEl.style.display = 'block';
        await this.cachePromises[this.currentCollection];
        if (this.gridOverlayEl) this.gridOverlayEl.style.display = 'none';
      }

      const searchTerm = event.target.value.trim().toLowerCase();
      
      if (searchTerm) {
        const fullList = this.collectionCache[this.currentCollection] || [];
        const keywords = searchTerm.split(' ').filter(k => k !== '');
        const searchResults = fullList.filter(p => {
          const skuMatch = p.sku.includes(searchTerm);
          const titleMatch = keywords.every(keyword => p.title.includes(keyword));
          return titleMatch || skuMatch;
        });
        
        if (searchResults.length > 0) {
          this.productGridEl.innerHTML = '';
          searchResults.forEach(product => {
              this.productGridEl.insertAdjacentHTML('beforeend', product.outerHTML);
          });
        } else {
          this.productGridEl.innerHTML = '<p class="tw-text-center" style="padding-block: 3rem;">No products found.</p>';
        }
        
        this.productCountEl.textContent = searchResults.length;
        if (this.loaderEl) this.loaderEl.style.display = 'none';

      } else {
        if (this.currentFilters) {
          this._loadCollection(this.currentCollection);
        } else {
          const fullList = this.collectionCache[this.currentCollection] || [];
          this.productGridEl.innerHTML = '';
          fullList.forEach(product => {
            this.productGridEl.insertAdjacentHTML('beforeend', product.outerHTML);
          });
          
          const activeTab = this.container.querySelector(`.cstm-collection-tab.is-active`);
          if (activeTab) {
            this.productCountEl.textContent = activeTab.dataset.productCount || fullList.length;
          }

          const isCacheFullyBuilt = !this.cachePromises[this.currentCollection];
          if (this.loaderEl) {
              this.loaderEl.style.display = isCacheFullyBuilt ? 'none' : 'block';
          }
        }
      }
    });
  }

  onUnload() {
    if (this.sliderEl && this.sliderEl.swiper) this.sliderEl.swiper.destroy(true, true);
  }

  _initQuantityValidation() {
    this.productGridEl.addEventListener('input', (event) => {
      if (!event.target.matches('.cstm-product-row__qty-input')) return;

      const input = event.target;
      const maxStock = parseInt(input.dataset.max, 10);

      if (maxStock === 0) {
        input.value = 0;
        return;
      }
      
      if (input.value === '') return;

      const currentValue = parseInt(input.value, 10);

      if (isNaN(currentValue)) {
        input.value = 1;
        return;
      }

      if (currentValue > maxStock) {
        input.value = maxStock;
      }
      
      if (currentValue < 1) {
        input.value = 1;
      }
    });
  }

 _initTagToggle() {
    this.productGridEl.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('.cstm-tags-toggle-button');
      if (!toggleButton) return;

      const tagsContainer = toggleButton.closest('.cstm-tags-container');
      if (!tagsContainer) return;
      
      tagsContainer.classList.add('is-expanded');
    });
  }

  _initFilterDrawer() {
    if (!this.filterButton) return;
    this.filterButton.addEventListener('click', () => {
      const drawer = this.filterDrawerContainer.querySelector('#CustomFilterDrawer');
      if (drawer) {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
    this.filterDrawerContainer.addEventListener('click', (event) => {
      const drawer = this.filterDrawerContainer.querySelector('#CustomFilterDrawer');
      if (event.target.closest('[data-drawer-close]')) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      if (event.target.id === 'CustomFilterDrawer-Apply') {
        const form = this.filterDrawerContainer.querySelector('#CustomFacetFiltersForm');
        if (form) {
          this.currentFilters = new URLSearchParams(new FormData(form)).toString();
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
          this._loadCollection(this.currentCollection);
        }
      }
      if (event.target.id === 'CustomFilterDrawer-Clear') {
        const form = this.filterDrawerContainer.querySelector('#CustomFacetFiltersForm');
        if (form) form.reset();
        drawer.classList.remove('is-open');
        this.currentFilters = '';
        document.body.style.overflow = '';
        this._loadCollection(this.currentCollection);
      }
    });
  }

  async _loadFiltersForCollection(handle) {
    if (!handle) return;
    try {
      const response = await fetch(`/collections/${handle}?view=filters-only`);
      const htmlText = await response.text();
      this.filterDrawerContainer.innerHTML = htmlText;
      if (this.filterButton) this.filterButton.style.display = 'inline-flex';
    } catch(error) {
      console.error("Error fetching filters:", error);
      this.filterDrawerContainer.innerHTML = '';
      if (this.filterButton) this.filterButton.style.display = 'none';
    }
  }

  _initSpecDrawer() {
    document.addEventListener('click', (event) => {
      
      const openTrigger = event.target.closest('[data-drawer-trigger]');
      if (openTrigger) {
        event.preventDefault();
        const drawerId = openTrigger.dataset.drawerTrigger;
        const drawer = document.getElementById(drawerId);

        if (drawer) {
          document.querySelectorAll('.cstm-spec-drawer.is-open').forEach(d => d.classList.remove('is-open'));
          
          drawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      const closeTrigger = event.target.closest('[data-drawer-close]');
      if (closeTrigger) {
        const drawer = closeTrigger.closest('.cstm-spec-drawer');
        if (drawer && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    });
  }

  _initViewMore() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-view-more-button]');
      if (!button) return;

      const container = button.closest('[data-view-more-container]');
      const shortText = container.querySelector('.short-text');
      const fullText = container.querySelector('.full-text');

      const isShowingShort = shortText.style.display !== 'none';

      if (isShowingShort) {
        shortText.style.display = 'none';
        fullText.style.display = 'inline';
        button.textContent = 'View Less';
      } else {
        shortText.style.display = 'inline';
        fullText.style.display = 'none';
        button.textContent = 'View More';
      }
    });
  }

  _initModelFilterExtras() {
    this.filterDrawerContainer.addEventListener('input', (event) => {
      const searchInput = event.target.closest('[data-model-search]');
      if (!searchInput) return;

      const searchTerm = searchInput.value.trim().toLowerCase();
      const listContainer = searchInput.closest('.cstm-collapsible-filter__content').querySelector('[data-model-list-container]');
      if (!listContainer) return;

      const models = listContainer.querySelectorAll('li[data-model-name]');
      models.forEach(model => {
        const modelName = model.dataset.modelName;
        const isMatch = modelName.includes(searchTerm);
        model.classList.toggle('hidden', !isMatch);
      });
    });

    this.filterDrawerContainer.addEventListener('click', (event) => {
      const viewMoreButton = event.target.closest('[data-view-more-models]');
      if (!viewMoreButton) return;

      const listContainer = viewMoreButton.previousElementSibling;
      if (listContainer && listContainer.matches('[data-model-list-container]')) {
        const isExpanded = listContainer.classList.contains('is-expanded');
        listContainer.classList.toggle('is-expanded');
        viewMoreButton.textContent = isExpanded ? 'View More' : 'View Less';
      }
    });
  }
}

const customShopInstances = {};
function loadCustomShop(container) {
  const sectionId = container.dataset.sectionId;
  if (customShopInstances[sectionId]) customShopInstances[sectionId].onUnload();
  customShopInstances[sectionId] = new CustomShop(container);
}
document.querySelectorAll('[data-section-type="custom-main-shop"]').forEach(container => {
  loadCustomShop(container);
});
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector('[data-section-type="custom-main-shop"]');
  if (container) loadCustomShop(container);
});
document.addEventListener('shopify:section:unload', function(event) {
  const container = event.target.querySelector('[data-section-type="custom-main-shop"]');
  if (container) {
    const sectionId = container.dataset.sectionId;
    if (customShopInstances[sectionId]) {
      customShopInstances[sectionId].onUnload();
      delete customShopInstances[sectionId];
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const shopContainer = document.querySelector('[data-section-type="custom-main-shop"]');
  if (!shopContainer) return;

  shopContainer.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-popup-trigger-for]');
    if (!trigger) return;

    const productId = trigger.dataset.popupTriggerFor;
    const popup = document.querySelector(`[data-popup-id="${productId}"]`);
    
    if (popup) {
      popup.classList.remove('tw-hidden');
      document.body.style.overflow = 'hidden';
    }
  });

  function closePopup(popup) {
    if (!popup) return;
    popup.classList.add('tw-hidden');
    document.body.style.overflow = '';
  }

  shopContainer.addEventListener('click', function(event) {
    const closeButton = event.target.closest('[data-popup-close]');
    const overlay = event.target.closest('[data-popup-overlay]');
    
    if (closeButton || overlay) {
      const popup = event.target.closest('[data-popup-id]');
      closePopup(popup);
    }
  });

  shopContainer.addEventListener('click', function(event) {
    const thumbnail = event.target.closest('[data-popup-thumbnail]');
    if (!thumbnail) return;

    const popup = thumbnail.closest('[data-popup-id]');
    if (!popup) return;

    const mainImage = popup.querySelector('[id^="MainPopupImage-"]');
    const newImageUrl = thumbnail.dataset.fullImageUrl;

    if (mainImage && newImageUrl) {
      mainImage.src = newImageUrl;
      
      const allThumbnails = popup.querySelectorAll('[data-popup-thumbnail]');
      allThumbnails.forEach(th => {
        th.classList.remove('is-active', 'tw-border-blue-500');
        th.classList.add('tw-border-transparent');
      });

      thumbnail.classList.add('is-active');
      thumbnail.classList.remove('tw-border-transparent');
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === "Escape") {
      const openPopup = document.querySelector('[data-popup-id]:not(.tw-hidden)');
      if (openPopup) {
        closePopup(openPopup);
      }
    }
  });
});
